// Module & Permission tree content, mirrored from the real menu structure in
// cbqa/CBQAGLOBAL-CRM-FRONTEND (src/components/navbar/NavLinks.jsx) plus this
// app's own Master Data menu. Used to render the Job Title permission tree —
// each leaf node (no `children`) gets View/Read, Create, Update, Delete checkboxes.
const permissionModuleTree = [
  {
    key: 'dashboard',
    label: 'Dashboard',
  },
  {
    key: 'crm',
    label: 'CRM',
    children: [
      { key: 'crm.dashboard', label: 'Dashboard' },
      {
        key: 'crm.prospect',
        label: 'Prospect',
        children: [
          { key: 'crm.prospect.company', label: 'Company' },
          { key: 'crm.prospect.leads', label: 'Leads' },
          { key: 'crm.prospect.proposals', label: 'Proposals' },
        ],
      },
      { key: 'crm.clients', label: 'Clients' },
      { key: 'crm.project', label: 'Project' },
      { key: 'crm.expense', label: 'Expense' },
      {
        key: 'crm.sales',
        label: 'Sales',
        children: [
          { key: 'crm.sales.invoice', label: 'Invoice' },
          { key: 'crm.sales.payment', label: 'Payment' },
        ],
      },
      { key: 'crm.task', label: 'Task' },
      {
        key: 'crm.reports',
        label: 'Reports',
        children: [
          { key: 'crm.reports.analysis', label: 'Analysis' },
          { key: 'crm.reports.company', label: 'Company' },
          { key: 'crm.reports.leads', label: 'Leads' },
          { key: 'crm.reports.proposals', label: 'Proposals' },
          { key: 'crm.reports.projects', label: 'Projects' },
        ],
      },
      { key: 'crm.salesReport', label: 'Sales Report' },
      { key: 'crm.achievement', label: 'Achievement & Incentive' },
    ],
  },
  {
    key: 'audit',
    label: 'Audit Platform',
    children: [
      { key: 'audit.dashboard', label: 'Dashboard' },
      { key: 'audit.clients', label: 'Clients' },
      { key: 'audit.task', label: 'Task' },
      { key: 'audit.calendar', label: 'Calendar' },
      { key: 'audit.outputTemplate', label: 'Output Template' },
      { key: 'audit.certificateMonitoring', label: 'Certificate Monitoring' },
      { key: 'audit.competencyManagement', label: 'Competency Management' },
      { key: 'audit.financeConfirmation', label: 'Finance Confirmation' },
      { key: 'audit.auditorUtilization', label: 'Auditor Utilization' },
      {
        key: 'audit.libraries',
        label: 'Audit Libraries',
        children: [
          { key: 'audit.libraries.v1', label: 'Audit Libraries V1' },
          { key: 'audit.libraries.v2', label: 'Audit Libraries V2' },
        ],
      },
    ],
  },
  {
    key: 'projectManagement',
    label: 'Project Management',
    children: [
      { key: 'pm.dashboard', label: 'Dashboard' },
      { key: 'pm.projects', label: 'Projects' },
      { key: 'pm.timesheet', label: 'Timesheet' },
      {
        key: 'pm.library',
        label: 'Library',
        children: [
          { key: 'pm.library.dashboard', label: 'Dashboard' },
          { key: 'pm.library.projects', label: 'Projects' },
          { key: 'pm.library.clients', label: 'Clients' },
          { key: 'pm.library.members', label: 'Members' },
          { key: 'pm.library.kanban', label: 'Kanban' },
          { key: 'pm.library.tickets', label: 'Tickets' },
          { key: 'pm.library.templates', label: 'Templates' },
          { key: 'pm.library.activity', label: 'Activity' },
        ],
      },
    ],
  },
  {
    key: 'hris',
    label: 'HRIS',
    children: [
      { key: 'hris.employees', label: 'Employees' },
      {
        key: 'hris.expenses',
        label: 'Expenses',
        children: [
          { key: 'hris.expenses.dashboard', label: 'Dashboard' },
          {
            key: 'hris.expenses.claims',
            label: 'Claims',
            children: [
              { key: 'hris.expenses.claims.expenseClaim', label: 'Expense Claim' },
              { key: 'hris.expenses.claims.expenseClaimType', label: 'Expense Claim Type' },
            ],
          },
          {
            key: 'hris.expenses.advances',
            label: 'Advances',
            children: [
              { key: 'hris.expenses.advances.employeeAdvance', label: 'Employee Advance' },
              { key: 'hris.expenses.advances.paymentEntry', label: 'Payment Entry' },
              { key: 'hris.expenses.advances.journalEntry', label: 'Journal Entry' },
              { key: 'hris.expenses.advances.additionalSalary', label: 'Additional Salary' },
            ],
          },
        ],
      },
      { key: 'hris.department', label: 'Department' },
      { key: 'hris.leaves', label: 'Leaves' },
      { key: 'hris.payroll', label: 'Payroll' },
      { key: 'hris.performance', label: 'Performance' },
      { key: 'hris.recruitment', label: 'Recruitment' },
      { key: 'hris.shiftAttendance', label: 'Shift & Attendance' },
      { key: 'hris.taxBenefits', label: 'Tax & Benefits' },
      { key: 'hris.tenure', label: 'Tenure' },
    ],
  },
  {
    key: 'masterData',
    label: 'Master Data',
    children: [
      {
        key: 'masterData.businessPartner',
        label: 'Business Partner',
        children: [
          { key: 'masterData.businessPartner.companies', label: 'Companies' },
          { key: 'masterData.businessPartner.contacts', label: 'Contacts' },
        ],
      },
      { key: 'masterData.individualPartner', label: 'Individual Partner' },
      {
        key: 'masterData.solutionSetup',
        label: 'Solution Setup',
        children: [
          { key: 'masterData.solutionSetup.services', label: 'Services' },
          { key: 'masterData.solutionSetup.standards', label: 'Standards' },
        ],
      },
      {
        key: 'masterData.audit',
        label: 'Audit',
        children: [
          { key: 'masterData.audit.competency', label: 'Competency' },
          { key: 'masterData.audit.impartiality', label: 'Impartiality' },
          { key: 'masterData.audit.workflow', label: 'Workflow' },
        ],
      },
      {
        key: 'masterData.configuration',
        label: 'Configuration',
        children: [
          { key: 'masterData.configuration.department', label: 'Department' },
          { key: 'masterData.configuration.jobTitle', label: 'Job Title' },
        ],
      },
      { key: 'masterData.users', label: 'Users' },
    ],
  },
  {
    key: 'settings',
    label: 'System',
    children: [
      {
        key: 'settings.tools',
        label: 'Tools',
        children: [
          { key: 'settings.tools.createTemplate', label: 'Create Template' },
          { key: 'settings.tools.approvalWorkflow', label: 'Approval Workflow' },
          { key: 'settings.tools.rateManagement', label: 'Rate Management' },
          { key: 'settings.tools.createTypeUnit', label: 'Create Type Unit' },
          { key: 'settings.tools.proposalStage', label: 'Proposal Stage' },
          { key: 'settings.tools.formatNumber', label: 'Format Number' },
          { key: 'settings.tools.expenseCategory', label: 'Expense Category' },
          { key: 'settings.tools.chartOfAccount', label: 'Chart of Account' },
        ],
      },
      { key: 'settings.masterCurrency', label: 'Master Currency' },
      { key: 'settings.salesTarget', label: 'Sales Target' },
      {
        key: 'settings.rolePermissions',
        label: 'Role & Permissions',
        children: [
          { key: 'settings.rolePermissions.createRole', label: 'Create Role' },
          { key: 'settings.rolePermissions.setPermission', label: 'Set Permission' },
        ],
      },
      {
        key: 'settings.emailSettings',
        label: 'Email Settings',
        children: [
          { key: 'settings.emailSettings.emailTemplate', label: 'Email Template' },
          { key: 'settings.emailSettings.emailConfiguration', label: 'Email Configuration' },
        ],
      },
    ],
  },
];

export default permissionModuleTree;
